import YouTubePlayer from 'youtube-player'
import Site from 'stores/Site'

export default class Modal {
    constructor(el) {
        this.el = el

        const close = this.el.querySelector('.modal-close')
        const bg = this.el.querySelector('.modal-bg')

        close.addEventListener('click', this.toggle.bind(this))
        bg.addEventListener('click', this.toggle.bind(this))

        if (el.classList.contains('video-modal')) {
            this.videoReady = false
            const videoEl = el.querySelector('.video')
            const videoId = videoEl.getAttribute('data-id')

            this.video = YouTubePlayer(videoEl, {
                videoId: videoId,
                playerVars: {
                    origin: window.location.origin,
                    rel: 0
                }
            })

            this.video.on('stateChange', event => {
                if (event.data === 0) {
                    this.videoComplete()
                }
            })

            this.video.on('ready', () => {
                this.videoReady = true
            })
        }
    }

    show() {
        this.isActive = true

        Site.html.classList.add('modal-active')
        this.el.classList.add('active')

        if (this.videoReady) {
            this.video.playVideo()
        }
    }

    hide() {
        this.isActive = false

        Site.html.classList.remove('modal-active')
        this.el.classList.remove('active')

        if (this.videoReady) {
            this.videoComplete()
        }
    }

    videoComplete(){
        this.video.seekTo(0)
        this.video.pauseVideo()
    }

    toggle() {
        if (this.isActive) {
            this.hide()
        } else {
            this.show()
        }
    }
}